import { isDomainError } from '@/core/errors/DomainError';
import { AppError } from '@/infrastructure/errors/AppError';

/**
 * Turns whatever a mutation rejected with into a sentence for the user.
 * Domain and application errors already carry German messages; anything else
 * gets a neutral fallback rather than a stack trace.
 */
export function describeError(error: unknown): string | null {
  if (error === null || error === undefined) {
    return null;
  }

  if (error instanceof AppError || isDomainError(error)) {
    return error.message;
  }

  return 'Die Aktion konnte nicht ausgeführt werden. Bitte erneut versuchen.';
}
